import BaseModel from 'models/BaseModel';

export default class AntiFraudCheckModel extends BaseModel {}
